import {
  Card,
  Grid,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from "@mui/material";
import React from "react";

const GRID_ITEM_STYLE = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
};

const PaginationComponent = ({
  count = 0,
  page = 0,
  perPage = 10,
  sortBy = "id",
  sortOrder = "desc",
  setPage,
  setPerPage,
  setSortOrder,
  setSortBy,
}) => {
  return (
    <Card
      width="100%"
      sx={{
        textAlign: "center",
        padding: 2,
        marginTop: 2,
      }}
    >
      <Grid container width="100%" spacing={2}>
        <Grid item xs={4} style={GRID_ITEM_STYLE}>
          <Typography fontWeight={600}>Página: {page + 1}</Typography>
          <Typography variant="subtitle2">Total de registros encontrados: {count}</Typography>
          <Pagination
            count={Math.ceil(count / perPage)}
            page={page + 1}
            onChange={(event, value) => {
              setPage(value - 1);
            }}
          />
        </Grid>
        <Grid item xs={1.5} style={GRID_ITEM_STYLE}>
          <Typography fontWeight={600}>Itens por página</Typography>
          <Select
            value={perPage}
            onChange={(event) => {
              const value = Number(event.target.value);
              setPerPage(value);
              if (typeof setPage === 'function') setPage(0); // volta para a primeira página
            }}
            fullWidth
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={30}>30</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={1.5} style={GRID_ITEM_STYLE}>
          <Typography fontWeight={600}>Ordenar por:</Typography>
          <Select
            value={sortBy}
            onChange={(event) => {
              const value = event.target.value;
              setSortBy(value);
            }}
            fullWidth
          >
            <MenuItem value="id">ID</MenuItem>
            <MenuItem value="createdAt">Data de criação</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={2} style={GRID_ITEM_STYLE}>
          <Typography fontWeight={600}>Ordenação</Typography>
          <Select
            value={sortOrder}
            onChange={(event) => {
              const value = event.target.value;
              setSortOrder(value);
            }}
            fullWidth
          >
            <MenuItem value="asc">Crescente</MenuItem>
            <MenuItem value="desc">Descrescente</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Card>
  );
};

export default PaginationComponent;
